var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useContext, useEffect, useState } from 'react';
import { InfoPerksContext, PerkProgressContext } from '../../../../contexts';
import { HasPerksSummaryMobile } from './HasPerksSummaryMobile';
import { HasPerksSummaryDesktop } from './HasPerksSummaryDesktop';
export var HasPerksSummary = function (_a) {
    var isMobile = _a.isMobile, statePack = _a.statePack;
    var modalState = statePack.modalState, detailState = statePack.detailState;
    var _b = useContext(InfoPerksContext), perksList = _b.perksList, isLoading = _b.isLoading;
    var activatedPerks = useContext(PerkProgressContext).activatedPerks;
    var setOpenPerksDetailModal = modalState[1];
    var setCurrentPerkDetails = detailState[1];
    var initialList = activatedPerks === null || activatedPerks === void 0 ? void 0 : activatedPerks.map(function (data) {
        var _a;
        return (__assign(__assign({}, (_a = data === null || data === void 0 ? void 0 : data.item) === null || _a === void 0 ? void 0 : _a.tierPerks[0]), { isManuallyFirst: true }));
    });
    var _c = useState(__spreadArray([], initialList, true)), currentList = _c[0], setCurrentList = _c[1];
    useEffect(function () {
        if (!isLoading)
            setCurrentList(__spreadArray(__spreadArray([], initialList, true), perksList, true));
    }, [isLoading, activatedPerks === null || activatedPerks === void 0 ? void 0 : activatedPerks.length]);
    if (isLoading) {
        return null;
    }
    return isMobile ? (React.createElement(HasPerksSummaryMobile, { setOpenPerksDetailModal: setOpenPerksDetailModal, setCurrentPerkDetails: setCurrentPerkDetails, perksList: currentList })) : (React.createElement(HasPerksSummaryDesktop, { setOpenPerksDetailModal: setOpenPerksDetailModal, setCurrentPerkDetails: setCurrentPerkDetails, perksList: currentList }));
};
